import { Verdict } from '@exam-center/graphql';
import { z } from 'zod';

export const examCenterProctorRequestVerdictFormSchema = z
  .object({
    verdict: z.nativeEnum(Verdict).optional(),
    comment: z.string().optional(),
    action: z.enum(['submit', 'save']).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.action === 'submit' && !data.verdict) {
      ctx.addIssue({
        path: ['verdict'],
        code: z.ZodIssueCode.custom,
        message: 'กรุณาเลือกผลการอนุมัติคำขอ',
      });
    }
  });

export type ExamCenterProctorRequestVerdictFormType = z.infer<
  typeof examCenterProctorRequestVerdictFormSchema
>;
